import { ActionReducerMap } from '@ngrx/store';

import * as fromAuth from './auth/auth.reducer';
import * as fromAlert from './alert/alert.reducer';
import * as fromAction from './action/action.reducer';


export interface State {
  auth: fromAuth.State;
  alert: fromAlert.State;
  action: fromAction.State;
}

export const reducers: ActionReducerMap<State> = {
  auth: fromAuth.reducer,
  alert: fromAlert.reducer,
  action: fromAction.reducer,
};



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/index.ts